import AlertMessage from 'components/ui/AlertMessage/AlertMessage';
import BookingStatusMessage from 'components/ui/BookingStatusMessage/BookingStatusMessage';
import { MESSAGE_TYPE_TO_BOOKING_STATUS_MAP } from '../constants';
import DefaultMessage from './DefaultMessage';
import { SpecialMessageProps } from './types';

export const PreApprovalMessage = ({ msg, lastEdits, booking, index }: SpecialMessageProps) => {
  // @ts-ignore
  const value = MESSAGE_TYPE_TO_BOOKING_STATUS_MAP[msg.type];

  return value && value.booking_status && booking.state === 'pre_approved' && lastEdits.preApproval === index ? (
    // return value && value.booking_status && data.booking.state === 'pre_approved' && value.booking_status !== 'undefined' ? (
    <BookingStatusMessage
      status={value.booking_status}
      text={
        `The booking is ${value.booking_status}`
        // ${MESSAGE_TYPE_TO_BOOKING_STATUS_MAP[`booking_${value && value.booking_status ? value.booking_status.replace('-','_') : msg.messageType}`].short_name || msg.messageType.replace('booking_','')}
      }
    />
  ) : null;
};

export const ApprovedOrRolodexCancelMessage = ({ msg }: SpecialMessageProps) => {
  // @ts-ignore
  const value = MESSAGE_TYPE_TO_BOOKING_STATUS_MAP[msg.type];

  return value && value.booking_status ? (
    <BookingStatusMessage
      status={value.booking_status}
      text={
        `The booking is ${value.booking_status}`
        // ${MESSAGE_TYPE_TO_BOOKING_STATUS_MAP[`booking_${value && value.booking_status ? value.booking_status.replace('-','_') : msg.messageType}`].short_name || msg.messageType.replace('booking_','')}
      }
    />
  ) : (
    <DefaultMessage message={msg} />
  );
};

export const RenterSpecialOfferMessage = ({ msg }: SpecialMessageProps) => (
  <AlertMessage
    headerText={msg.body}
    bodyText="You have 24 hours to book with this special offer before it expires. Upon payment, your request will be automatically approved."
  />
);

export const OwnerSpecialOfferMessage = ({ userName }: SpecialMessageProps) => (
  <AlertMessage
    headerText={`You sent ${userName} a special offer for their booking inquiry.`}
    bodyText="The offer you sent is valid for 24 hours and the requested time is blocked on your calendar. Upon payment, their booking request will be automatically approved."
  />
);
